// Shared status palette (redesign). Status ids come from the backend:
// 1 On hold · 2 In progress · 3 Done · 4 Archived · 5 On going · 6 Potential
export const STATUS_COLORS = {
  1: '#f59f00',
  2: '#4f7cff',
  3: '#12b886',
  4: '#8b8fb0',
  5: '#a855f7',
  6: '#ec4899',
};

const pill = (color, extra = '') =>
  `background: color-mix(in srgb, ${color} 14%, transparent); color: ${color}; padding: 4px 12px; border-radius: 99px; border: none; ` +
  `font-size: 12px; font-weight: 700; white-space: nowrap; text-align: center; display: inline-flex; align-items: center; justify-content: center; gap: 6px; ${extra}`;

// Inline style string for a status pill/button; `extra` keeps view-specific sizing.
export function statusStyle(id, extra = '') {
  const color = STATUS_COLORS[id];
  return color ? pill(color, extra) : 'text-align:center';
}

// Hosting statuses are text based ('Active', 'Expires soon', 'Expired').
export function hostingStatusStyle(statusText) {
  const color = { 'Expires soon': '#f59f00', Expired: '#f03e5e', Active: '#12b886' }[statusText] || '#8b8fb0';
  return pill(color, 'height: 30px;');
}
